import React from 'react'
import ReactDOM from 'react-dom'
import ObliqueStrategy from './components/ObliqueStrategy'

import './styles.scss'

const rootElement = document.getElementById('root')
ReactDOM.render(<ObliqueStrategy />, rootElement)
